import React from "react";
import styled from "styled-components";
import TableView from "./table/TableView";

export default function ActiveCustomerLeaderboardPage() {
  return (
    <Wrapper>    
      <TableView />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 80px;
`
